type LoadingProps = {
  message?: string;
};

export default function Loading(props: LoadingProps) {
  return (
    <div className="flex h-screen justify-center items-center w-full flex-grow z-[100]">
      <div className="flex flex-col items-center">
        <div className="w-16 h-16 border-b-4 border-red-600 rounded-full animate-spin"></div>
        <div className="p-2 mt-4 text-primary-blue font-semibold tracking-[0.07rem]">
          {props.message ?? "LOADING"}
        </div>
      </div>
    </div>
  );
}
